module.exports = __webpack_public_path__ + "static/media/S4N8-2.95ce1540.svg";